import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { getHeaderConfigRTK } from '.';
import getBaseQueryUrl from './getBaseQueryUrl';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params, headers }) => {
    try {
      const config = getHeaderConfigRTK(method);
      const response = await axios({
        url: baseUrl + url,
        method: method,
        data,
        params,
        ...config,
      });
      return { data: response.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const api = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: getBaseQueryUrl() }),
  endpoints: (build) => ({
    getGraphDetail: build.query({
      query: () => ({ url: 'dashboard/graph-detail' }),
    }),
  }),
  tagTypes: ['Company', 'Person', 'Fund Detail', 'References'],
});

const getMethodFromRequestType = (requestType = 'GET') => {
  let response = requestType.toLowerCase();
  return response;
};

export const { useGetGraphDetailQuery } = api;
